import Vue from 'vue'
import Notifications from 'vue-notification'
import VeeValidate, { Validator } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import vueMoment from 'vue-moment'
import moment from 'moment'

import App from './App'
import router from './router'
import store from './store'
import Domino from './directives/domino'
import inputUI from './common/directives/inputUI'
import selectUI from './common/directives/selectUI'
import baseModal from './common/components/baseModal'
import agTable from './common/components/ag-table'
import toggleInput from './common/components/toggle-input'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import customSelect from './common/components/Form/CustomSelect'
import Loader from './common/components/loader'
require('moment/locale/fr')

// Style for Ag-Grid
import '../node_modules/ag-grid/dist/styles/ag-grid.css'
import '../node_modules/ag-grid/dist/styles/ag-theme-balham.css'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://34307821ed5b45ee831db2713ca8d484@sentry.io/1846640',
  environment: process.env.NODE_ENV,
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

Vue.use(Domino)
Vue.use(inputUI)
Vue.use(selectUI)
Vue.use(Notifications)
Validator.localize('fr', fr)
Vue.use(VeeValidate)
Vue.use(vueMoment, { moment })
Vue.component('v-select', vSelect)
Vue.component('base-modal', baseModal)
Vue.component('ag-table', agTable)
Vue.component('multiselect', Multiselect)
Vue.component('toggle-input', toggleInput)
Vue.component('loader', Loader)
Vue.component('custom-select', customSelect)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	template: '<App/>',
	components: {
		App,
		// baseModal,
		// toggleInput,
		// vSelect,
		// Multiselect,
		// customSelect
	},
	created: function () {
		window.Vue = this
	},
	store,
	router
})



// WEBPACK FOOTER //
// ./src/main.js